// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"0475098f","943":"26f6e226"}[chunkId] + ".chunk.js";
};